export default __webpack_public_path__ + "static/media/pdf-icn.3a501551.svg";